import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';

export default function LegalAcceptancePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const session = useStore(s => s.session);
  const getPendingLegal = useStore(s => s.getPendingLegal);
  const acceptLegal = useStore(s => s.acceptLegal);

  if (!session?.member_id) { navigate('/login'); return null; }

  const pending = getPendingLegal(session.member_id);

  const typeLabel = (dt: string) => {
    if (dt === 'terms') return t('legal.termsTitle');
    if (dt === 'privacy') return t('legal.privacyTitle');
    return t('legal.cookiesTitle');
  };

  const handleAcceptAll = () => {
    pending.forEach(d => acceptLegal(session.member_id!, d.document_type, d.version));
    navigate('/house');
  };

  if (pending.length === 0) { navigate('/house'); return null; }

  return (
    <div className="min-h-dvh bg-ivory flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-2">
          <h1 className="font-serif text-2xl tracking-widest">{t('legal.title')}</h1>
          <p className="text-xs text-charcoal/50 font-sans">{t('legal.mustAccept')}</p>
        </div>
        <div className="space-y-3">
          {pending.map(d => (
            <div key={d.id} className="border border-charcoal/10 p-4 flex items-center justify-between">
              <div>
                <p className="text-sm font-sans font-medium">{typeLabel(d.document_type)}</p>
                <p className="text-[10px] text-charcoal/40 font-sans">v{d.version}</p>
              </div>
              <button onClick={() => acceptLegal(session.member_id!, d.document_type, d.version)}
                className="text-[10px] tracking-widest uppercase font-sans text-gold hover:text-charcoal transition-colors">
                {t('legal.accept')}
              </button>
            </div>
          ))}
        </div>
        <button onClick={handleAcceptAll}
          className="w-full py-3 bg-charcoal text-ivory text-[11px] tracking-widest-xl uppercase font-sans hover:bg-charcoal/90 transition-colors">
          {t('legal.accept')}
        </button>
      </div>
    </div>
  );
}
